import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { Fragment } from "react"
import { userActions } from "../../../../../store/user-slice"

const ResortComponent = (props) => {
    const { type, name } = props
    const { resort } = useFilter()
    let filteredUsers = useSelector((state) => state.user.filteredUsers)
    let users=useSelector(state=>state.user.users)
    let dispatch = useDispatch()

    return <Fragment>
        <label>{name}</label><select className="mb-2"
            onChange={(event) => {
                let value = event.target.value

                switch (value) {
                    case 'ASC':
                        dispatch(userActions.setFilteredItems(resort(filteredUsers??users, type, 'ASC')))
                        break

                    case 'DESC':
                        dispatch(userActions.setFilteredItems(resort(filteredUsers??users, type, 'DESC')))
                        break
                }

            }}

        >
            <option value='' >Sort</option>
            <option value='ASC' >Ascending</option>
            <option value='DESC' >Descending</option>
        </select>
    </Fragment>
}


export default ResortComponent